import { Tooltip, Typography } from "@mui/material";

const TruncatedText: React.FC<{
    text: string;
    maxLength?: number;
    variant?: 'h6' | 'body2';
    sx?: any;
    onClick?: () => void;
    children?: React.ReactNode;
}> = ({ text, maxLength = 20, variant = 'body2', sx, onClick, children }) => {
    const shouldTruncate = text && text.length > maxLength;
    const displayText = shouldTruncate ? `${text.substring(0, maxLength)}...` : text;
    
    const textElement = (
        <Typography
            variant={variant}
            sx={{
                ...sx,
                cursor: onClick ? 'pointer' : 'default',
                wordBreak: 'break-all',
                overflowWrap: 'break-word',
                hyphens: 'auto',
            }}
            onClick={onClick}
        >
            {children}{displayText}
        </Typography>
    );

    return shouldTruncate ? (
        <Tooltip 
            title={text} 
            arrow 
            placement="top"
            componentsProps={{
                tooltip: {
                    sx: {
                        fontSize: '0.95rem',
                        padding: '10px 10px',
                        maxWidth: 'none'
                    },
                },
            }}
        >
            {textElement}
        </Tooltip>
    ) : (
        textElement
    );
};

export default TruncatedText;